const imageExtensions = ['jpg', 'jpeg', 'png', 'JPEG', 'JPG', 'PNG'];

export const isImageExtension = (fileExtension: string) =>
  imageExtensions.includes(fileExtension);

export const getPlaceholder = (fileExtension: string): string => {
  const extensionToPlaceholder: { [key: string]: string } = {
    mp4: '/placeholder-video.svg',
    mov: '/placeholder-video.svg',
    avi: '/placeholder-video.svg',
    wmv: '/placeholder-video.svg',
    doc: '/placeholder-word.svg',
    docx: '/placeholder-word.svg',
    xls: '/placeholder-excel.svg',
    xlsx: '/placeholder-excel.svg',
    svg: '/placeholder-svg.svg',
    pdf: '/placeholder-pdf.svg',
    eps: '/placeholder-eps.svg',
    ai: '/placeholder-illustrator.svg',
    psd: '/placeholder-photoshop.svg',
    indd: '/placeholder-indesign.svg',
  };

  return extensionToPlaceholder[fileExtension] || 'placeholder-document.svg';
};

export const getImageMimeType = (filename: string) => {
  const extension = filename.split('.').pop()?.toLowerCase();

  if (extension === 'png' || extension === 'svg' || extension === 'ai') {
    return 'image/png';
  }

  if (extension === 'gif') {
    return 'image/gif';
  }

  return 'image/jpeg';
};

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const getReadableDate = (dateValue: string) => {
  const date = new Date(dateValue);

  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};
